/**
 * ISO 3166-1 country names (English short form) — full list.
 * Used by the intake form's Country field as a datalist so browsers
 * offer type-ahead suggestions without needing a paid Google Places key.
 */
export const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain',
  'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
  'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada',
  'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia',
  'Comoros', 'Congo (Brazzaville)', 'Congo (Kinshasa)', 'Costa Rica', 'Croatia', 'Cuba',
  'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic',
  'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia',
  'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia',
  'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau',
  'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran',
  'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan',
  'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia',
  'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands',
  'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia',
  'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
  'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea',
  'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama',
  'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
  'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'São Tomé and Príncipe',
  'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore',
  'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea',
  'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland',
  'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo',
  'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu',
  'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States',
  'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen',
  'Zambia', 'Zimbabwe',
];

/**
 * Popular destination cities keyed by country. Not comprehensive — clients
 * can still type freely. Kept to the top 5-10 cities relevant to pet
 * relocation clients (Cayman ⇄ US/UK/Canada/Australia most common).
 */
export const CITIES_BY_COUNTRY = {
  'Cayman Islands': ['George Town', 'West Bay', 'Bodden Town', 'East End', 'North Side'],
  'United States': ['Miami', 'Atlanta', 'New York', 'Los Angeles', 'Houston', 'Chicago', 'Dallas', 'Boston', 'Orlando', 'Tampa'],
  'United Kingdom': ['London', 'Manchester', 'Edinburgh', 'Birmingham', 'Glasgow', 'Bristol'],
  'Canada': ['Toronto', 'Vancouver', 'Montreal', 'Calgary', 'Ottawa'],
  'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide'],
  'Ireland': ['Dublin', 'Cork', 'Galway'],
  'Germany': ['Berlin', 'Frankfurt', 'Munich', 'Hamburg'],
  'France': ['Paris', 'Lyon', 'Marseille', 'Nice'],
  'Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague'],
  'Spain': ['Madrid', 'Barcelona', 'Valencia', 'Seville'],
  'Italy': ['Rome', 'Milan', 'Florence', 'Naples'],
  'Switzerland': ['Zurich', 'Geneva', 'Bern'],
  'Jamaica': ['Kingston', 'Montego Bay', 'Ocho Rios'],
  'Bahamas': ['Nassau', 'Freeport'],
  'Barbados': ['Bridgetown'],
  'Trinidad and Tobago': ['Port of Spain'],
  'South Africa': ['Cape Town', 'Johannesburg', 'Durban'],
  'New Zealand': ['Auckland', 'Wellington', 'Christchurch'],
  'Singapore': ['Singapore'],
  'Hong Kong': ['Hong Kong'],
  'United Arab Emirates': ['Dubai', 'Abu Dhabi'],
};
